// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { AiComponentWithRelationsSchema } from './AiComponentRelationsSchema'
import type { AiComponentWithRelations } from './AiComponentRelationsSchema'
import { AiComponentRelationSchema } from './AiComponentRelationSchema';

/////////////////////////////////////////
// AI COMPONENT RELATION RELATION SCHEMA
/////////////////////////////////////////

export type AiComponentRelationRelations = {
  application: ApplicationWithRelations;
  source: AiComponentWithRelations;
  target: AiComponentWithRelations;
};

export type AiComponentRelationWithRelations = Omit<z.infer<typeof AiComponentRelationSchema>, "metadata"> & {
  metadata?: JsonValueType | null;
} & AiComponentRelationRelations

export const AiComponentRelationWithRelationsSchema: z.ZodType<AiComponentRelationWithRelations> = AiComponentRelationSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  source: z.lazy(() => AiComponentWithRelationsSchema),
  target: z.lazy(() => AiComponentWithRelationsSchema),
}))